import { render, staticRenderFns } from "./PayInPerson.vue?vue&type=template&id=12747e5a&scoped=true"
import script from "./PayInPerson.vue?vue&type=script&lang=js"
export * from "./PayInPerson.vue?vue&type=script&lang=js"
import style0 from "./PayInPerson.vue?vue&type=style&index=0&id=12747e5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12747e5a",
  null
  
)

export default component.exports